import { connect } from 'react-redux';
import patientSelector from '../../selectors/PatientSelector';
import InsuranceCardLightBoxView from './InsuranceCardLightBoxView';
import {
    trackSwitchImageInPreview,
    closeImagePreview,
} from '../../actions/InsuranceCardLightBoxActions';

export const mapStateToProps = state => {
    const patient = patientSelector(state);
    const { showInsuranceCardLightBox } = patient;
    const { insuranceCardImageUrls } = patient.selectedInsuranceCard || {};

    const images = [];
    if (insuranceCardImageUrls && insuranceCardImageUrls.front) {
        images.push(insuranceCardImageUrls.front);
    }

    if (insuranceCardImageUrls && insuranceCardImageUrls.back) {
        images.push(insuranceCardImageUrls.back);
    }

    return {
        showInsuranceCardLightBox,
        images,
    };
};

export const mapDispatchToProps = {
    closeImagePreview,
    trackSwitchImageInPreview,
};

export const InsuranceCardLightBox = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsuranceCardLightBoxView);
